import { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import RootLayouts from "./layouts/Rootlayout/Rootlayout";
import {
  createBrowserRouter,
  Route,
  createRoutesFromElements,
  RouterProvider,
} from "react-router-dom";
import Home from "./pages/Home/Home";
import About from "./pages/About/About";
import CurrentProperties from "./pages/Portfolio/CurrentProperties/CurrentProperties";
import PastProperties from "./pages/Portfolio/PastProperties/PastProperties";
import Investments from "./pages/Investments/Investments";
import PropertyServices from "./pages/PropertyServices/PropertyServices";
import SPiServices from "./pages/SPiServices/SPiServices";
import Contact from "./pages/Contact/Contact";
import OverlayPage from "./pages/Portfolio/CurrentProperties/OverlayPage";
import OverlayPage2 from "./pages/Portfolio/PastProperties/OverlayPage";




import ErrorPage from "./pages/ErrorPage/ErrorPage";

import "./App.css";


const BASEURL = process.env.REACT_APP_SOMPROP_BASE_URL;

const router = createBrowserRouter(

  
  createRoutesFromElements(
    <Route path={`${BASEURL}`} element={<RootLayouts />}>
      <Route path={`${BASEURL}/`} element={<Home />} />
      <Route path={`${BASEURL}/about`} element={<About />} />
      <Route
        path={`${BASEURL}/current-properties`}
        element={<CurrentProperties />}
      />
      <Route
        path={`${BASEURL}/current-properties/:propertySlug`}
        element={<OverlayPage />}
      />
      <Route
        path={`${BASEURL}/current-properties/:/*`}
        element={<ErrorPage />}
      />
      <Route path={`${BASEURL}/past-properties`} element={<PastProperties />} />
      <Route
        path={`${BASEURL}/past-properties/:propertySlug`}
        element={<OverlayPage2 />}
      />
      <Route path={`${BASEURL}/past-properties/:/*`} element={<ErrorPage />} />
      <Route path={`${BASEURL}/investments`} element={<Investments />} />
      <Route
        path={`${BASEURL}/property-services`}
        element={<PropertyServices />}
      />
      <Route path={`${BASEURL}/spi-services`} element={<SPiServices />} />
      <Route path={`${BASEURL}/contact`} element={<Contact />} />

    

      {/* Catch-all route for unmatched URLs */}
      {/* <Route path={`${BASEURL}/*`} element={<ErrorPage />} /> */}
      <Route path={`${BASEURL}/*`} element={<ErrorPage />} />
    </Route>
  )
);

function App() {
  useEffect(() => {
    const link = document.createElement("link");
    link.href =
      "https://fonts.googleapis.com/css2?family=Lato:wght@100;300;400;700;900&family=Montserrat:wght@100;200;300;400;500;600;700;800;900&display=swap";
    link.rel = "stylesheet";
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
    
  }, []);



  return <RouterProvider router={router} />;
}

export default App;
